import { fontSizes, colors } from '../../../../Components/consts'
import { styled } from '@mui/system'
import { Tabs } from '../../../../Components/LazyComponents'
import { EAST_GRADIENT, WEST_GRADIENT } from '../../../../Constant'

type ColProps = {
  side?: 'left' | 'right'
}

type TeamTabProps = {
  selectedTeam: 'east' | 'west' | 'team izzy' | 'team north'
}

export const BoxscoreStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(4),
}))

export const ASGLogoCon = styled('div')(({ theme }) => ({
  margin: theme.spacing(3, 0),
  width: '20%',
  [theme.breakpoints.down('sm')]: {
    width: '50%',
  },
}))

export const PlayerCardStyle = styled('div')<{ condensed?: boolean }>(
  ({ theme, condensed }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(0.75, 0),
    borderRadius: theme.spacing(1.5),
    background: `${colors.gray.gray80}10`,
    transition: 'all 0.2s ease-in-out',
    width: '100%',
    minWidth: condensed ? 250 : 350,
    maxWidth: condensed ? 250 : 350,
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0.5, 0),
      minWidth: condensed ? 220 : 280,
      maxWidth: condensed ? 220 : 280,
    },
    '&:hover': {
      background: `${colors.gray.gray80}60`,
      borderColor: colors.gray.gray60,
    },
    '& a': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textDecoration: 'none',
      width: '100%',
      minHeight: 100,
      [theme.breakpoints.down('sm')]: {
        minHeight: 50,
      },
    },
  })
)

export const PlayerInfoCon = styled('div')<{ condensed?: boolean }>(
  ({ theme, condensed }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: condensed ? 230 : 300,
    maxWidth: condensed ? 230 : 300,
    minHeight: 100,
    gap: theme.spacing(0.25),
    [theme.breakpoints.down('md')]: {
      minWidth: condensed ? 210 : 270,
      maxWidth: condensed ? 210 : 270,
      minHeight: 80,
    },
  })
)

export const PlayerProfileCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  '& img': {
    height: 48,
    width: 48,
    borderRadius: '50%',
    objectFit: 'cover',
    border: `2px solid ${colors.gray.gray60}`,
    [theme.breakpoints.down('sm')]: {
      height: 40,
      width: 40,
    },
  },
}))

export const ASRostersCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  '& .descCon': {
    width: '50%',
    margin: theme.spacing(5, 0),
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    '& p': {
      color: colors.gray.gray20,
      fontSize: fontSizes.medium,
      textAlign: 'center',
    },
  },
  '& .section': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    margin: theme.spacing(2, 0),
  },
}))

export const SubHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 1),
  '& p': {
    marginLeft: 2,
    fontSize: fontSizes.small,
    color: colors.gray.gray20,
  },
}))

export const TeamColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(0, 2),
  '& .teamImg': {
    height: 100,
    width: 100,
    margin: theme.spacing(1, 3),
    [theme.breakpoints.between('sm', 'md')]: {
      height: 75,
      width: 75,
      margin: theme.spacing(1, 2),
    },
    [theme.breakpoints.down('sm')]: {
      height: 65,
      width: 65,
      margin: theme.spacing(1),
    },
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
    minWidth: '90%',
  },
}))

export const TeamImageCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  width: '100%',
  '& .teamImg': {
    height: 150,
    width: 150,
    margin: theme.spacing(1, 3),
    [theme.breakpoints.between('sm', 'md')]: {
      height: 100,
      width: 100,
      margin: theme.spacing(1, 2),
    },
    [theme.breakpoints.down('sm')]: {
      height: 85,
      width: 85,
      margin: theme.spacing(1),
    },
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
    minWidth: '90%',
  },
}))

export const CoachColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(0, 2),
  minWidth: 400,
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
    minWidth: '70%',
  },
}))

export const RosterColumn = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(0, 1),
  width: '100%',
  maxWidth: 450,
  minHeight: 500,
  [theme.breakpoints.down('md')]: {
    maxWidth: 400,
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0, 0.5),
    maxWidth: '100%',
  },
}))

export const SecondaryRow = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
  '& > div': {
    '& img': {
      height: 25,
      width: 25,
      margin: theme.spacing(0, 0.5),
      [theme.breakpoints.down('sm')]: {
        height: 15,
        width: 15,
      },
    },
  },
  '& .accolade': {
    fontSize: '1rem',
    color: colors.gray.gray40,
    margin: theme.spacing(0, 1, 0.25),
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: 12,
    },
  },
  '& .positionText': {
    fontSize: '0.9rem',
    color: colors.gray.gray40,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: 11,
    },
  },
}))

export const PlayerStyleCon = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
  '& img': {
    height: 25,
    width: 25,
    margin: theme.spacing(0, 0.5),
    [theme.breakpoints.down('sm')]: {
      height: 18,
      width: 18,
    },
  },
}))

export const PlayerNameYearsCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  '& h3': {
    fontSize: fontSizes.medium,
    fontWeight: 600,
    margin: 0,
    color: colors.gray.gray20,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      fontWeight: 500,
    },
  },
}))

export const PlayerNumber = styled('div')(({ theme }) => ({
  fontSize: fontSizes.large,
  fontWeight: 700,
  color: colors.gray.gray40,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
  },
}))

export const PlayerDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  fontSize: fontSizes.small,
  color: colors.gray.gray40,
  margin: theme.spacing(0, 0, 2),
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.xSmall,
  },
}))

export const PlayerMeta = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: fontSizes.semiLarge,
  minWidth: 50,
  width: 50,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
    minWidth: 40,
    width: 40,
  },
  '& span': {
    fontWeight: 500,
    color: colors.gray.gray40,
  },
}))

export const PlayerAccoladeCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  fontSize: fontSizes.medium,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
  '& span': {
    fontWeight: 500,
    color: colors.gray.gray40,
  },
}))

export const PlayerTeam = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  '& img': {
    height: 30,
    width: 30,
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      height: 20,
      width: 20,
    },
  },
}))

export const RosterTeamTabs = styled(Tabs)<TeamTabProps>(({ theme, selectedTeam }) => ({
  width: '30%',
  background: selectedTeam === 'east' ? EAST_GRADIENT : WEST_GRADIENT,
  borderRadius: theme.spacing(8),
  zIndex: 20,
  margin: theme.spacing(2, 0),
  [theme.breakpoints.down('sm')]: {
    width: '85%',
  },
  '& .MuiTabs-indicator': {
    background: colors.white,
  },
  '& .MuiTab-root': {
    color: colors.white,
    fontWeight: 700,
    textShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorPrimary': {
    color: colors.white,
    fontWeight: 700,
    textShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .MuiTab-textColorPrimary.Mui-selected': {
    color: colors.white,
    fontWeight: 700,
    textShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
}))

export const TeamRosterPanelContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  minHeight: 500,
  '& .rosterSection': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    width: '100%',
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  '& .leftColumn': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
  },
  '& .rightColumn': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))

export const PlayerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-around',
  width: '100%',
  height: 48,
  position: 'relative',
}))

export const PlayerNameAccoladeCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(5),
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}))

export const ProfilePlaceholder = styled('div')(({ theme }) => ({
  height: 48,
  width: 48,
  borderRadius: '50%',
  backgroundColor: `${colors.gray.gray60}60`,
  border: `2px solid ${colors.gray.gray60}`,
  [theme.breakpoints.down('sm')]: {
    height: 40,
    width: 40,
  },
}))
